<template>
  <div class="panel">
    <div v-if="title">
      <div class="title">
        <div class="dashed">{{title}}</div>
        <div>
          <slot name="tools"></slot>
        </div>
      </div>

      <div style="border-bottom: 1px solid #eeeeee;padding: 0px 0px;margin: 0 10px;margin-bottom: 10px"></div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "index",
    props: ["title"]
  }
</script>

<style scoped>
  .panel {
    background-color: #fff;
    padding: 10px 10px 10px;
    box-shadow: rgba(84, 162, 245, 0.1) 1px 0px 2px 1px;
    margin-bottom: 10px;

  }

  .title {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }

  .dashed {
    color: #4A80BA;
    font-size: 18px;
    font-family: PingFang HK;
    font-weight: 400;
  }
</style>
